// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"571":"stencil-polyfills-dom","952":"stencil-polyfills-css-shim"}[chunkId] || chunkId) + "." + {"55":"2e78f766","76":"e8f4a11d","157":"a7d3c521","571":"074a41af","826":"ca6a69bb","868":"07fd21f9","908":"f3532702","952":"8d46a0e6"}[chunkId] + ".chunk.js";
};